import { render, staticRenderFns } from "./DiagnosisCaseCard.vue?vue&type=template&id=6571f532&scoped=true&"
import script from "./DiagnosisCaseCard.vue?vue&type=script&lang=js&"
export * from "./DiagnosisCaseCard.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisCaseCard.vue?vue&type=style&index=0&id=6571f532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6571f532",
  null
  
)

export default component.exports